/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditLogListResponse } from '../../models/audit-log-list-response';

export interface QueryAuditLogs$Params {

/**
 * Start of time range (ISO-8601 format). Defaults to 1 day ago if not specified.
 */
  from?: string;

/**
 * End of time range (ISO-8601 format). Defaults to now if not specified.
 */
  to?: string;

/**
 * Filter by scope type (USER or TENANT only)
 */
  scope_type?: 'USER' | 'TENANT';

/**
 * Filter by the ID of the affected entity (e.g., specific user ID, tour ID, case ID)
 */
  scope_id?: string;

/**
 * Filter by event type
 */
  event_type?: 'USER_CREATED' | 'TENANT_CREATED';

/**
 * Filter by the ID of the actor who performed the action
 */
  actor_id?: string;

/**
 * Page number (0-based). First page is 0.
 */
  page?: number;

/**
 * Number of items per page. Maximum allowed is 1000.
 */
  size?: number;
}

export function queryAuditLogs(http: HttpClient, rootUrl: string, params?: QueryAuditLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditLogListResponse>> {
  const rb = new RequestBuilder(rootUrl, queryAuditLogs.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('scope_type', params.scope_type, {});
    rb.query('scope_id', params.scope_id, {});
    rb.query('event_type', params.event_type, {});
    rb.query('actor_id', params.actor_id, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuditLogListResponse>;
    })
  );
}

queryAuditLogs.PATH = '/api/v2/audit-logs';
